export class CorruptActiveProfile extends Error {
    constructor(profile) {
        super("The active profile is corrupted, please create a new one.\n" +
            `Profile: ${JSON.stringify(profile)}`);
    }
}
